import { render, staticRenderFns } from "./upgradeLog.vue?vue&type=template&id=3d55cb5a&scoped=true"
import script from "./upgradeLog.vue?vue&type=script&lang=js"
export * from "./upgradeLog.vue?vue&type=script&lang=js"
import style0 from "./upgradeLog.vue?vue&type=style&index=0&id=3d55cb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d55cb5a",
  null
  
)

export default component.exports